module.exports = __webpack_public_path__ + "static/media/kingz_square.c9838b61.png";